import objectFitImages from "object-fit-images";
var windowWidth;

$(document).ready(function (evt) {
  windowWidth = $(window).width();
  CheckMediaSizes();
  objectFitImages();
});

$(window).on("resize", function (evt) {
  // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
  if ($(window).width() != windowWidth) {
    // Take note of updated window width in case of another resize
    windowWidth = $(window).width();

    CheckMediaSizes();
  }
});

function CheckMediaSizes() {
  $(document)
    .find(".responsive")
    .each(function () {
      var media = $(this);
      var sizes = media.attr("data-sizes");
      var url = null;

      try {
        sizes = JSON.parse(sizes);
      } catch (error) {
        console.error(error);
        return false;
      }

      if (media.is("source")) {
        for (var i = 0; i < sizes.length; i++) {
          if (
            sizes[i].max === undefined ||
            media.parent("video").siblings("img").outerWidth() <= sizes[i].max
          ) {
            url = sizes[i].url;
            break;
          }
        }
      } else {
        for (var i = 0; i < sizes.length; i++) {
          if (
            sizes[i].max === undefined ||
            media.outerWidth() <= sizes[i].max
          ) {
            url = sizes[i].url;
            break;
          }
        }
      }

      if (url) {
        if (media.is("img")) {
          media.attr("src", url);
        } else if (media.is("source")) {
          media.attr("src", url);
          media.parent("video").get(0).load();
        } else {
          media.css("background-image", "url(" + url + ")");
        }
      }
    });
}
